import React from 'react'
import { Heading, Paragraph } from '@scentregroup/ui'

import { Link as LinkType } from '../../../types/link'
import style from './index.scss'
import ReturnsIcon from './returns.inline.svg'
import CashbackIcon from './wallet.inline.svg'
import DeliveryIcon from './delivery.inline.svg'
import DirectLogo from './westfield-direct-logo.inline.svg'

export const MarketplaceBillboard: React.FC<{
  Link: LinkType
}> = ({ Link }) => (
  <div className={style.MarketplaceBillboard}>
    <Link to="/shop/products" className={style.headingLink}>
      <Heading type="medium">Shop online with</Heading>
      <DirectLogo className={style.logo} />
    </Link>
    <div className={style.container}>
      <Link to="/shop/products" className={style.proposition}>
        <div className={style.iconWrapper}>
          <DeliveryIcon className={style.icon} />
        </div>
        <Paragraph>Free same day delivery*</Paragraph>
      </Link>
      <Link to="/shop/products" className={style.proposition}>
        <div className={style.iconWrapper}>
          <CashbackIcon className={style.icon} />
        </div>
        <Paragraph>5% cashback on all Click & Collect orders</Paragraph>
      </Link>
      <Link to="/shop/products" className={style.proposition}>
        <div className={style.iconWrapper}>
          <ReturnsIcon className={style.icon} />
        </div>
        <Paragraph>Easy returns by mail or in-centre*</Paragraph>
      </Link>
    </div>
  </div>
)
